import type { UseQueryResult } from '@tanstack/react-query';
import { useQuery } from '@tanstack/react-query';
import { useContext } from 'react';
import type Result from 'true-myth/result';

import { ApplicationContext } from '~/shared/context/context';
import type { JobArchitecturePermissions } from '~/shared/data-contract/job-architecture';
import { jobArchitecturePermissionsSchema } from '~/shared/data-contract/job-architecture';
import type { Pathname } from '~/shared/http-fetcher/http-fetcher';

const pathname: Pathname = '/job-architectures/options';

export const useJobArchitectureOptionsQuery = (): UseQueryResult<Result<JobArchitecturePermissions, Error>> => {
    const { validatingCobrainerApiFetcher } = useContext(ApplicationContext);

    return useQuery({
        queryFn: () =>
            validatingCobrainerApiFetcher.get(jobArchitecturePermissionsSchema, {
                pathname,
            }),
        queryKey: [pathname, 'get', jobArchitecturePermissionsSchema],
    });
};
